import React from "react";
import BreadCrumb from "../../../components/BreadCrumb";
// import TournamentsWrapper from "./TournamentsWrapper";
import MatchesWrapper from "./MatchesWrapper";
import PointsTable from "./PointsTable";
import LeagueStats from "./LeagueStats";
// import GlobalSearchBar from "../../../components/common/GlobalSearchBar";

const HomePage: React.FC = () => {
  return (
    <div className="custom-container main-middle-content-wrap home-container">
      <div className="home-wrapper">
        <div className="home-top-bar">
          <BreadCrumb />

        </div>

        {/* ---------- Tournaments carousel ---------- */}
        {/* <TournamentsWrapper/> */}

        {/* ---------- Matches carousel ---------- */}
        <MatchesWrapper />

        {/* ---------- Points Table ---------- */}
        <PointsTable />

        {/* ---------- League Stats (unchanged) ---------- */}
        <LeagueStats />
      </div>
    </div>
  );
};

export default HomePage;
